export default [
  {
    check: false,
    title: "조경작업(예초기)",
    list: [
      {
        content: "1. 보호구 지급 및 착용을 하였는가?",
        isChecked: "",
      },
      {
        content: "2. 벌·해충 등에 대한 약제 및 기피제 등을 지급하였는가?",
        isChecked: "",
      },
      {
        content: "3. 구급약품 및 용구를 비치하였는가?",
        isChecked: "",
      },
      {
        content: "4. 예초기의 날 접촉예방장치를 부착하였는가?",
        isChecked: "",
      },
      {
        content: "5. 예초기 시동 시 주변근로자 접근을 금지하고 주변 장애물에 부딪히지 않게 하고 있는가?",
        isChecked: "",
      },
      {
        content: "6. 예초기 작업 시 안전거리 10m 이상 확보 하였는가?",
        isChecked: "",
      },
      {
        content: "7. 예초기 날이 돌 또는 굵은 나무 등의 방해물에 부딪히지 않는가?",
        isChecked: "",
      },
      {
        content: "8. 예초기를 우측에서 좌측방향으로 하는가?",
        isChecked: "",
      },
      {
        content: "9. 급경사지에서 작업하지 않고 있는가?",
        isChecked: "",
      },
      {
        content: "10. 예초기를 들고 이동시 근로자와 안전거리 확보하고 이동하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "원심기",
    list: [
      {
        title: "동력 전달부",
        content: "1. 벨트, 풀리 등의 위험 부위는 노출되어 있지 않은가?",
        isChecked: "",
      },
      {
        title: "동력 전달부",
        content: "2. 볼트, 키 등의 고정구가 돌출되어 회전하지는 않는가?",
        isChecked: "",
      },
      {
        title: "조작반",
        content: "3. 조작 스위치(버튼)는 표시가 명확한가?",
        isChecked: "",
      },
      {
        title: "조작반",
        content: "4. 시동(ON), 정지(OFF)장치의 기능은 확실한가?",
        isChecked: "",
      },
      {
        title: "회전체",
        content: "5. 회전 날개에는 부식 및 마모가 없는가?",
        isChecked: "",
      },
      {
        title: "회전체",
        content: "6. 주축 및 베어링부의 이상음, 진동 및 이상발열은 없는가?",
        isChecked: "",
      },
      {
        title: "회전체",
        content: "7. 볼트의 풀림은 없는가?",
        isChecked: "",
      },
      {
        title: "방호장치",
        content: "8. 비상 정지 장치는 확실하게 작동하는가?",
        isChecked: "",
      },
      {
        title: "방호장치",
        content: "9. 원심기에는 덮개나 울이 설치되어 있는가?",
        isChecked: "",
      },
      {
        title: "방호장치",
        content: "10. 리미트 스위치가 설치되어 덮개나 울을 열면 기계는 멈추는가?",
        isChecked: "",
      },
      {
        title: "전기계통",
        content: "11. 스위치 커버가 파손되지 않았는가?",
        isChecked: "",
      },
      {
        title: "전기계통",
        content: "12. 전선의 연결상태가 양호한가?",
        isChecked: "",
      },
      {
        title: "전기계통",
        content: "13. 접지선이 연결되어 있는가?",
        isChecked: "",
      },
      {
        title: "전기계통",
        content: "14. 배선의 피복에 손상된 부분은 없는가?",
        isChecked: "",
      },
      {
        title: "작업",
        content: "15. 기계를 반드시 정지시키고 내용물에 접근하는가?",
        isChecked: "",
      },
      {
        title: "작업",
        content: "16. 타력 회전을 손으로 정지시키지는 않는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "공기압축기",
    list: [
      {
        content: "1. 압축기가 운전중일때에는 벨트커버나 회전부에 가까이 가지 않는가?",
        isChecked: "",
      },
      {
        content: "2. 압축기를 작동하기 전에 압축기 주변에 다칠 위험이 있는 사람은 없는지 확인 후 가동하는가?",
        isChecked: "",
      },
      {
        content: "3. 작업시작 전 점검 시 압력게이지, 온도계 등을 점검하여 공기압축기가 정상작동임을 확인하는가?",
        isChecked: "",
      },
      {
        content: "4. 공기압축기는 정상적인 대기 공기많을 흡입하여 압축하도록 설계되어 있으므로 다른 종류의 가스, 기체, 증기류는 절대로 공기압축기에 흡수되거나 사용하지 않는가?",
        isChecked: "",
      },
      {
        content: "5. 공기압축기의 정비작업 개시 전에 리모트 컨트롤러를 포함하여 모든 전원을 차단하는가?",
        isChecked: "",
      },
      {
        content: "6. 압축기의 청소 정비시에는 반드시 압축기를 정지하고 모든 전원을 차단한 다음 내부압력이 완전히 방출된 후 충분히 냉각된 상태에서 실시하는가?",
        isChecked: "",
      },
      {
        content: "7. 적합한 규격의 안전밸브를 설치하였는가?",
        isChecked: "",
      },
      {
        content: "8. 안전밸브는 설정압력을 변경하거나 그 기능을 제한하거나 플러그 등으로 대체하지 않았는가?",
        isChecked: "",
      },
      {
        content: "9. 공기압축기의 시스템 어느 부분에도 플라스틱 파이프, 고무호스의 사용 및 납땜을 하지 않았는가?",
        isChecked: "",
      },
      {
        content: "10. 에어필터나 부품의 세척시 인화성 또는 독성이 있는 솔벤트, 신나 등의 사용을 금지하였는가?",
        isChecked: "",
      },
      {
        content: "11. 공기압축기가 작동중일때에는 정비작업을 실시하지 않는가?",
        isChecked: "",
      },
      {
        content: "12. 규정된 압력이상으로 공기압축기를 작동시키지 않는가?",
        isChecked: "",
      },
      {
        content: "13. 공기압축기 작동중에는 보호커버나 판넬 등을 제거하지 않는가?",
        isChecked: "",
      },
      {
        content: "14. 항상 공기압축기에 적합한 윤활유를 사용하고 교환주기를 지키는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "금속절단기",
    list: [
      {
        content: "1. 안전커버 및 벨트 덮개가 견고하게 부착되어 있는가?",
        isChecked: "",
      },
      {
        content: "2. 전원케이블의 손상은 없는가?",
        isChecked: "",
      },
      {
        content: "3. 절단석의 균열이나 이빠짐 등 손상은 없는가?",
        isChecked: "",
      },
      {
        content: "4. 가공물은 고정장치 등을 이용하여 견고하게 고정하고 작업을 실시하는가?",
        isChecked: "",
      },
      {
        content: "5. 절단 불티 비산 방향을 확인하여 비산 방지 조치를 실시하는가?",
        isChecked: "",
      },
      {
        content: "6. 가공물 교체 또는 이상 조치는 절단기를 정지한 상태에서 실시하는가?",
        isChecked: "",
      },
      {
        content: "7. 귀마개, 보안경, 및 방진 마스크를 착용하고 작업을 실시하는가?",
        isChecked: "",
      },
      {
        content: "8. 절단작업시 숫돌에 충격이 가지 않도록 하는가?",
        isChecked: "",
      },
      {
        content: "9. 절단작업 시작전 1분정도 덮개를 설치한 상태로 공회전을 시키는가?",
        isChecked: "",
      },
      {
        content: "10. 절단기의 회전속도에 상응하는 숫돌을 사용하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "지게차",
    list: [
      {
        content: `1. 운전원 면허 자격이 있는가?<br/>
        - 3톤이상 : 건설기계조종사면허<br/>
        - 3톤미만 : 소형건설기계조종교육 이수<br/>
        - 건설기계관리법 비적용 지게차 : 지게차조종교육과정(12H)이수`,
        isChecked: "",
      },
      {
        content: "2. 자재 하역작업 외 사용금지하는가?",
        isChecked: "",
      },
      {
        content: `3. 운전자의 시야 확보를 하는가?<br/>
        (화물 과다적재, 포크 과다상승 상태 운행금지)`,
        isChecked: "",
      },
      {
        content: "4. 포크에 화물을 매단 상태로 운행(급선회)하는가?",
        isChecked: "",
      },
      {
        content: `5. 전용통로 확보 및 작업지휘자를 통한 작업자 출입제한을 하는가?<br/>
        (지게차 운행통로에 근로자 출입통제)`,
        isChecked: "",
      },
      {
        content: "6. 사업장 내 제한속도 지정 및 준수하는가?",
        isChecked: "",
      },
      {
        content: "7. 후진시 협착위험 예방대책을 포함한 작업계획서 작성하였는가?",
        isChecked: "",
      },
      {
        content: "8. 화물을 적재하고 경사지 오를 경우 전진주행, 내려갈 경우 후진주행 준수하는가?",
        isChecked: "",
      },
      {
        content: "9. 승차석 외에 근로자 탑승운행금지 준수하는가?",
        isChecked: "",
      },
      {
        content: "10. 유압장치(모터, 실린더, 배관 등) 누설, 손상 및 마모 상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "11. 타이어 손상 및 마모 상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "12. 수리·점검항목 등 이력기록 관리상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "13. 화물 과다적재 및 편하중 적재하지 않는가?",
        isChecked: "",
      },
      {
        content: "14. 좌석안전띠 설치 및 착용상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "15. 전조등 및 후미등 점등상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "16. 헤드가드 및 백레스트 설치상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: `17. 후방확인장치 설치상태는 이상없는가?<br/>
        (후사경, 룸미러, 후방경보장치, 후방카메라 등)`,
        isChecked: "",
      },
      {
        content: "18. 운행경로상의 사각지대 반사경 설치상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "19. 운전석의 조작장치 및 제동장치 등 작동상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "20. 운전석의 조작장치 및 제동장치 등 작동상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "21. 카운트 웨이트 추가 금지 준수 및 고정상태는 이상없는가?",
        isChecked: "",
      },
      {
        content: "22. 경사지 주차금지 준수하는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "진공포장기",
    list: [
      {
        content: "1. 진공포장 작업 시 고열에 의한 화상사고의 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "2. 컨베이어벨트에 말릴 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "3. 장시간 서서 작업 시 근골격계 부담이 되지 않는가?",
        isChecked: "",
      },
      {
        content: "4. 포장기의 이동식 바퀴의 상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "5. 진공포장기 바퀴 고정장치는 양호한가?",
        isChecked: "",
      },
      {
        content: "6. 진공포장기 전선의 절연상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "7. 진공포장기 전선의 정리상태는 양호한가?",
        isChecked: "",
      },
      {
        content: "8. 진공포장기 작업 중 찔리거나 베임의 위험은 없는가?",
        isChecked: "",
      },
      {
        content: "9. 진공포장기에 비상정지 버튼은 부착 되어 있고, 정상 작동하는가?",
        isChecked: "",
      },
      {
        content: "10. 선별기 바닥면 주변에 물기가 상존하고 있지는 않는가?",
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "랩핑기",
    list: [
      {
        content: "1. 동력전달부의 벨트, 풀리 등에 울, 덮개 등의 방호 조치가 되어 있는가?",
        isChecked: "",
      },
      {
        content: "2. 비상정지스위치는 정상적으로 작동하는가?",
        isChecked: "",
      },
      {
        content: "3. 가동스위치는 안전조치(스위치 덮개, 울 등)가 되어 있는가?",
        isChecked: "",
      },
      {
        content: "4. 구동모터에 접지선이 연결되어 있는가?",
        isChecked: "",
      },
      {
        content: "5. 케이블(전선)의 피복에 벗겨진 부분은 없는가?",
        isChecked: "",
      },
      {
        content: "6. 적재물 랩핑 시 움직이지 않게 고정하였는가?",
        isChecked: "",
      },
      {
        content: "7. 제품 적재 시 편하중이 없는가?",
        isChecked: "",
      },
      {
        content: "8. 제품 적재 시 편하중이 없는가?",
        isChecked: "",
      },
      {
        content: "9. 작업 중 흡연, 잡담, 휴대폰 통화 등 불필요한 행동을 금지하고 있는가?",
        isChecked: "",
      },
      {
        content: "10. 작업장 주변에 정리정돈은 잘되어 있는가?",
        isChecked: "",
      },
    ],
  },
];
